import React from "react"
import styled from "styled-components"
import Star from "../images/star.svg";

const StarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 0 1rem 0;
  img {
    width: 100%;
    max-width: 25px;
    margin: 0 10px 0 0;
  }
`

const StarRating = styled.p`
  font-size: 25px;
  margin: 0 10px 0 0;
  color: gold;
  line-height: 1;
`

const StarBar = (props) => {
  const { starCount } = props;
  const stars = [];

  for (let i = 0; i < starCount; i++) {
    stars.push(<img key={i} src={Star} alt="Filled in gold star"/>)
  }

  return (
    <StarContainer {...props}>
      <StarRating>{starCount}</StarRating>
      {stars}
    </StarContainer>
  )
}

export default StarBar;